import React from 'react'
import {NoCustomerExpenseComponentProps} from './expense-dashboard'

export const NoCustomerExpenseComponent: React.FC<NoCustomerExpenseComponentProps> = ({
    learnMoreUrl,
    expenseDetailUrl
}) => {
    return (
        <div className="text-center my-5 text-2xl font-semibold">
            <p className="mb-5">
                Keep your HSA receipts organized easily{' - '}
                <a
                    className="underline"
                    href={learnMoreUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Learn More.
                </a>
            </p>
            <p>
                Ready to go?{' '}
                <a
                    className="underline"
                    href={expenseDetailUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Click here
                </a>{' '}
                to connect to or create your HSA Store Expense Dashboard Account.
            </p>
        </div>
    )
}
